import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createBlock(_component_el_pagination, {
    background: false,
    layout: "total, sizes, prev, pager, next",
    onCurrentChange: $options.changePage,
    onSizeChange: $options.changeSize,
    "hide-on-single-page": true,
    "current-page": $props.pagination.current_page,
    "page-sizes": $options.page_sizes,
    "page-size": $props.pagination.per_page,
    total: $props.pagination.total
  }, null, 8 /* PROPS */, ["onCurrentChange", "onSizeChange", "current-page", "page-sizes", "page-size", "total"]);
}